import Vue from 'vue';
import Point from '../components/Point';

const ToastConstructor = Vue.extend(Point);
function showPoint(msg) {
  const pointAlter = new ToastConstructor({
    data() {
      return {
        flag: true,
        duration: 1000,
        message: msg || '加载失败',
      };
    },
  });
  setTimeout(() => {
    pointAlter.flag = false;
  }, pointAlter.duration);
  // 将实例挂载到body下
  document.body.appendChild(pointAlter.$mount().$el);
}

export default showPoint;



// WEBPACK FOOTER //
// ./src/utils/Point.js